export default {
  paused: 'I pagamenti online sono in pausa a causa di problemi di verifica KYC.',
  deadline_warning: 'La verifica KYC è obbligatoria, altrimenti i pagamenti online verranno sospesi il {{date}}.',
  complete_verification: 'Completa la verifica',
  partner: {
    action_needed:
      "Il tuo fornitore di pagamenti ha bisogno di un'ultima cosa prima che questo ristorante possa accettare pagamenti online.",
    hosted_incomplete:
      'Non hai ancora completato la configurazione dei pagamenti online con il tuo fornitore di pagamenti.',
    link_expired:
      'Il link per completare la configurazione dei pagamenti online è scaduto. Ottienine uno nuovo per continuare.',
    open_error: 'Impossibile contattare il provider di pagamento. Riprova tra qualche minuto.',
    hosted_not_started: 'I pagamenti online non sono ancora configurati con il tuo fornitore di pagamenti.',
    business_details_missing: 'Aggiungi i dettagli della tua attività per iniziare ad accettare pagamenti online.',
    continue: 'Continua',
  },
};
